module.exports = __webpack_public_path__ + "static/media/turtle.14ce6fda.svg";